import { create } from 'zustand';
import { adminOrderApi } from '@api/api-config.ts';
import { AdminOrderListResponse, OrderStatus } from '@api/generated/portal-be-admin';

export interface OrderFilters {
  portalId?: number;
  status?: OrderStatus;
  orderNumber?: string;
  ecid?: string;
  supplierId?: number;
  customerId?: number;
  /** Smluvní (fakturační) skupina objednávající firmy — `contract_groups.id`. */
  contractGroupId?: number;
  deliveryFrom?: string;
  deliveryTo?: string;
  createdFrom?: string;
  createdTo?: string;
  /** Jen objednavky, u kterych nedosel e-mail a nikdo to neresil (v seznamu vykricnik). */
  emailProblem?: boolean;
  /** Jen objednavky, kterym chybi povinne PDF. */
  pdfMissing?: boolean;
  page: number;
  size: number;
}

interface PaginationInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

interface AdminOrderStoreState {
  loading: boolean;
  error: string | null;
  data: AdminOrderListResponse[] | null;
  pagination: PaginationInfo | null;
  loadOrders: (filters: OrderFilters) => Promise<void>;
}

export const useAdminOrderStore = create<AdminOrderStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  pagination: null,

  loadOrders: async (filters: OrderFilters) => {
    try {
      set({ loading: true, error: null });
      const response = await adminOrderApi.getOrders({
        page: filters.page,
        size: filters.size,
        portalId: filters.portalId,
        status: filters.status,
        orderNumber: filters.orderNumber,
        ecid: filters.ecid,
        supplierId: filters.supplierId,
        customerId: filters.customerId,
        contractGroupId: filters.contractGroupId,
        deliveryFrom: filters.deliveryFrom,
        deliveryTo: filters.deliveryTo,
        createdFrom: filters.createdFrom,
        createdTo: filters.createdTo,
        emailProblem: filters.emailProblem,
        pdfMissing: filters.pdfMissing,
      });
      const result = response.data;
      set({
        loading: false,
        error: null,
        data: result.items || [],
        pagination: {
          page: result.page,
          size: result.size,
          total: result.total,
          totalPages: result.totalPages,
          hasPrev: result.hasPrev,
          hasNext: result.hasNext,
        },
      });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba při načítání objednávek',
      });
    }
  },
}));
